import { SiteLanguages } from 'src/types/values/siteLanguage';
import { isOneOf } from 'src/utils/isOneOf';

export function getLanguage(value: string | null): SiteLanguages {
    const languages = [SiteLanguages.German, SiteLanguages.English];
    return isOneOf(value, languages) ? value : SiteLanguages.German;
}
